import Axios from 'axios';

const axiosInstances = ({ baseURL, headers, withCredentials = true }) => {
  const instance = Axios.create({
    baseURL,
    headers,
    withCredentials
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        if (window.location.pathname !== '/403') {
          window.location.href = '/403';
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default axiosInstances;
